import axios from "axios";
import React from "react";

import { useLocalStorage } from "../hooks";

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { getUrlForUsers } from "../utils/confighelpers";
import NotificationItem from "./NotificationItem";

export default function Notifications() {
  const [userToken] = useLocalStorage("userToken");
  const [notifList, setNotifList] = React.useState([]);

  React.useEffect(() => {
    (async () => {
      const config = {
        method: "get",
        url: `${getUrlForUsers()}notificationsList?page=${0}&limit=${20}&sortBy=${"asc"}`,
        headers: {
          "x-access-token": userToken,
        },
      };
      const request = await axios(config);
      if (request.status === 200) {
        if (request.data.statusCode === 200) {
          setNotifList([...request.data.data.notificationList]);
        }
      }
    })();
  }, [userToken]);

  return (
    <div>
      <Menu as="div" className="relative">
        <MenuButton className="p-1.5 md:p-1.5 text-gray-400 hover:text-gray-500 rounded-full border border-gray-300">
          <svg className="xs:size-5 sm:size-5 md:size-7 2xl:size-7" width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M17.4944 3.66602C11.0277 3.66602 8.21799 9.52157 8.21799 13.3924C8.21799 16.2855 8.63744 15.4341 7.03605 18.9632C5.08049 23.9924 12.9444 26.048 17.4944 26.048C22.043 26.048 29.9069 23.9924 27.9527 18.9632C26.3513 15.4341 26.7708 16.2855 26.7708 13.3924C26.7708 9.52157 23.9597 3.66602 17.4944 3.66602Z" stroke="#212121" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.8625 29.9141C18.975 32.0224 16.0306 32.0474 14.125 29.9141" stroke="#212121" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            {/* <ellipse cx="26.938" cy="7.29297" rx="4.25347" ry="4.375" fill="#F75555" /> */}
          </svg>
        </MenuButton>
        <MenuItems
          transition
          className="absolute right-0 z-10 mt-2.5 [min-w-36] max-h-96 min-w-0 w-60 xs:w-72 sm:w-80 lg:w-96 overflow-y-auto flex-auto origin-top-right rounded-md bg-white py-2 ring-1 shadow-lg ring-gray-900/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in divide-y divide-gray-200"
        >

          {notifList.map((data) => (
            <MenuItem key={data.notificationId}>
              <NotificationItem
                key={data.notificationId}
                imgSrc={data.senderInfo.profilePic}
                displayText={data.notificationBody}
                personName={data.senderInfo.fullName}
                timeElapsed={data.createdAt}
              />
            </MenuItem>
          ))}
        </MenuItems>
      </Menu>
    </div>
  );
}
